import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { printEPTourLabel } from '../../../../../redux/actions/activePickTour.actions';
import { getActivePickTourState } from '../../../../../redux/selectors';

import styles from '../PickItem/PickItem.css';

type Props = {
  pickLineNumber: string;
};

export const ReprintButton = ({ pickLineNumber }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const activePickTourState = useSelector(getActivePickTourState);
  const pickTourList = activePickTourState?.data?.pickTourList || [];

  const selectedPick = useMemo(() => {
    return pickTourList.find(item => `${item.pickTourItemDetailLineNumber}` === pickLineNumber);
  }, [pickTourList, pickLineNumber]);

  const handleReprintClick = (event: React.MouseEvent) => {
    if (selectedPick && activePickTourState?.data) {
      dispatch(
        printEPTourLabel({
          data: [{...activePickTourState?.data, pickTourList: [selectedPick]}, ],
        })
      );
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
  };

  return (
    <div className={styles.reprintLabels}>
      <button type="button" onClick={handleReprintClick} aria-label={t('ORDER_LIST.LIST_ITEM.REPRINT_LABEL')}>
        {t('ORDER_LIST.LIST_ITEM.REPRINT_LABEL')}
      </button>
    </div>
  );
};
